module.exports = __webpack_public_path__ + "static/logo-white-f93009d52bf826534b19fb15639245ef.png";